import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { ContainerModel } from '@app/models/server/layout.model';
import { AboutSchema } from '@b2b/seo-util-lib';

@Component({
  selector: 'app-b2b-breadcrumb',
  templateUrl: './b2b-breadcrumb.component.html',
  styleUrls: ['./b2b-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class B2bBreadcrumbComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  };

  @Input() linkColor: string;
  @Input() textColor: string;

  @Input() breadcrumbs: AboutSchema[];

  constructor() {}

  ngOnInit() {}
}
